<template>
  <div id="sales-value-contribution">
    <b-card class="responsive-card">
      <b-card-header>
        <b-card-title class="text-center">Sales Value Contribution by Salesperson</b-card-title>
      </b-card-header>
      <!-- Bar Chart -->
      <div class="chart-container">
        <apexchart
          type="bar"
          :height="chartOptions.chart.height"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "SalesValueContribution",
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    topSalespersons() {
      const salesData = new Map();
      this.data.forEach(({salesPersonName, totalSales }) => {
        salesData.set(salesPersonName, (salesData.get(salesPersonName) || 0) + totalSales);
      });

      return [...salesData.entries()]
        .map(([salesPersonName, totalSales]) => ({ salesPersonName, totalSales }))
        .sort((a, b) => b.totalSales - a.totalSales)
        .slice(0, 6); // Top 6 salespersons
    },
    series() {
      return [{
        name: "Total Sales Value",
        data: this.topSalespersons.map(person => person.totalSales)
      }];
    },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: "bar",
          toolbar: { show: false }
        },
        xaxis: {
          categories: this.topSalespersons.map(person => person.salesPersonName),
          title: { text: "Salespersons" },
        },
        yaxis: {
          title: { text: "Total Sales Value" },
          labels: {
            formatter: (value) => `${value.toLocaleString()}`,
          },
        },
        dataLabels: {
          enabled: window.innerWidth > 768, // Hide on small screens
          formatter: (value) => `${value.toLocaleString()}`,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%",
          },
        },
        fill: {
          colors: ["#b0cc48"], // Green bars
        },
        tooltip: {
          y: {
            formatter: (value) => `${value.toLocaleString()}`,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
      };
    }
  }
};
</script>

<style scoped>
#sales-value-contribution {
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  #sales-value-contribution {
    margin: 10px;
  }
}
</style>
